/* @flow */
import styled from "styled-components";

const StyledWidgetReadOnlyEmptyValue = styled.span`
  opacity: 0.5;
`;

export default StyledWidgetReadOnlyEmptyValue;
